import { dateToString, type IParsedNotificationData, showDataAgo } from '@repo/sdk'
import { Button } from '@repo/ui'
import { cn } from '@repo/ui/lib'
import { ArrowRightIcon, X } from 'lucide-react'

export const ToastNotification = ({
  isToast,
  notification,
  ...props
}: {
  isClosable?: boolean
  isToast?: boolean
  notification?: IParsedNotificationData
  onClose?: () => void
}) => {
  if (!notification?.type) {
    return <p>Error bad notification type</p>
  }

  const { borderLeftColor, buttons, isNew, text } = notification
  const { created_at } = notification
  const { destination, origin } = notification.load

  return (
    <div
      className={cn(
        'flex w-full max-w-xl gap-1 rounded-s bg-white px-4 py-2 dark:bg-[#262626]',
        borderLeftColor ?? 'border-l-gray-200',
        'shadow-none',
      )}
    >
      <div>
        {text}
        <div className={'mt-1 flex max-w-xl flex-wrap text-sm'}>
          <p className={'font-semibold'}>{origin}</p>
          <ArrowRightIcon
            style={{
              height: '24px',
              width: '24px',
            }}
          />
          <p className={'font-semibold'}>{destination}</p>
        </div>
        {created_at && dateToString(created_at)}
        <p className={'my-1 text-xs text-gray-500'}>
          {isNew ? 'Now' : created_at && showDataAgo(new Date(created_at))}
        </p>
        {buttons}
      </div>
      {props?.isClosable && (
        <Button onClick={props?.onClose} variant="ghost">
          <X size={16} />
        </Button>
      )}
    </div>
  )
}
